// src/Hooks/useBanner.ts
import { useQuery } from '@tanstack/react-query';
import { BannerService } from '../Services/bannerService';
import { Banner } from '../common-components/Banner-Popup/banner';

const BANNER_QUERY_KEY = ['banner', 'popup'] as const;

async function fetchActiveBanner(): Promise<Banner | null> {
  const banners = await BannerService.getBanners();
  if (!banners.length) return null;
  return banners[0]; // There is only ever 0 or 1 banner
}

export const useBanner = () => {
  return useQuery({
    queryKey: BANNER_QUERY_KEY,
    queryFn: fetchActiveBanner,
    staleTime: 1000 * 60 * 1, // 10 minutes — banner rarely changes
    retry: 1,
  });
};